export default {
	validate: function(form, swal, time) {
		let montoPrestamoTmp;
		if (form.montoPrestamo) {
			montoPrestamoTmp = form.montoPrestamo;
			montoPrestamoTmp = montoPrestamoTmp.replace(/\$/g, '');
			montoPrestamoTmp = montoPrestamoTmp.replace(/\,/g, '');
		}

		if (form.valorPropiedad) {
			form.valorPropiedad = form.valorPropiedad.replace(/\$/g, '');
			form.valorPropiedad = form.valorPropiedad.replace(/\,/g, '');
		}

		if (form.ingreso) {
			form.ingreso = form.ingreso.replace(/\$/g, '');
			form.ingreso = form.ingreso.replace(/\,/g, '');
		}
				
		if (montoPrestamoTmp < 200000) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'El monto del prestamo debe estar entre los $200,000.00 y los $5,000,000.00'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('montoPrestamo').classList.add('is-invalid');
			document.getElementById('montoPrestamo').focus();

			return false;
		}else {
			if (document.getElementById('montoPrestamo').classList.contains('is-invalid'))
				document.getElementById('montoPrestamo').classList.remove('is-invalid');
		}

		if (montoPrestamoTmp > 5000000) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'El monto del prestamo debe estar entre los $200,000.00 y los $5,000,000.00'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('montoPrestamo').classList.add('is-invalid');
			document.getElementById('montoPrestamo').focus();

			return false;
		}else {
			if (document.getElementById('montoPrestamo').classList.contains('is-invalid'))
				document.getElementById('montoPrestamo').classList.remove('is-invalid');
		}

		if (form.plazos == 0) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar el plazo del prestamo'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('plazos').classList.add('is-invalid');
			document.getElementById('plazos').focus();

			return false;
		}else {
			if (document.getElementById('plazos').classList.contains('is-invalid'))
				document.getElementById('plazos').classList.remove('is-invalid');
		}

		if (form.nombre == null || form.nombre == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar tu(s) nombre(s) y apellidos'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('nombre').classList.add('is-invalid');
			document.getElementById('nombre').focus();

			return false;
		}else {
			if (document.getElementById('nombre').classList.contains('is-invalid'))
				document.getElementById('nombre').classList.remove('is-invalid');
		}

		if (form.ingreso == null || form.ingreso == '' || form.ingreso == 0) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar tu ingreso mensual'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('nombre').classList.add('is-invalid');
			document.getElementById('nombre').focus();

			return false;
		}else {
			if (document.getElementById('nombre').classList.contains('is-invalid'))
				document.getElementById('nombre').classList.remove('is-invalid');
		}

		if (form.email == null || form.email == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar un email válido'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('email').classList.add('is-invalid');
			document.getElementById('email').focus();

			return false;
		}else {
			let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

			if (!reg.test(form.email)) {
				swal({
					type: 'error'
					,title: 'Oops...'
					,text: 'Debes especificar un email válido'
					,toast: true
			        ,position: 'top-end'
			        ,showConfirmButton: false
			        ,timer: time
				});

				document.getElementById('email').classList.add('is-invalid');
				document.getElementById('email').focus();

				return false;
			}else {
				if (document.getElementById('email').classList.contains('is-invalid'))
					document.getElementById('email').classList.remove('is-invalid');
			}
		}

		if (form.telefono == null || form.telefono == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar un teléfono válido'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('telefono').classList.add('is-invalid');
			document.getElementById('telefono').focus();

			return false;
		}else {
			if (document.getElementById('telefono').classList.contains('is-invalid'))
				document.getElementById('telefono').classList.remove('is-invalid');
		}

		if (form.tipoPropiedad == 0) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar el tipo de propiedad'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('tipoPropiedad').classList.add('is-invalid');
			document.getElementById('tipoPropiedad').focus();

			return false;
		}else {
			if (document.getElementById('tipoPropiedad').classList.contains('is-invalid'))
				document.getElementById('tipoPropiedad').classList.remove('is-invalid');
		}

		if (form.valorPropiedad == 0) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar el valor de propiedad'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('valorPropiedad').classList.add('is-invalid');
			document.getElementById('valorPropiedad').focus();

			return false;
		}else {
			if (document.getElementById('valorPropiedad').classList.contains('is-invalid'))
				document.getElementById('valorPropiedad').classList.remove('is-invalid');
		}

		if (form.valorPropiedad == null || form.valorPropiedad == 0) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar en valor aproximado de tu propiedad'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('valorPropiedad').classList.add('is-invalid');
			document.getElementById('valorPropiedad').focus();

			return false;
		}else {
			if (document.getElementById('valorPropiedad').classList.contains('is-invalid'))
				document.getElementById('valorPropiedad').classList.remove('is-invalid');
		}

		if (form.cp == null || form.cp == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar el Código postal'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('cp').classList.add('is-invalid');
			document.getElementById('cp').focus();

			return false;
		}else {
			if (document.getElementById('cp').classList.contains('is-invalid'))
				document.getElementById('cp').classList.remove('is-invalid');
		}

		if (form.estado == null || form.estado == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar el estado'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('estado').classList.add('is-invalid');
			document.getElementById('estado').focus();

			return false;
		}else {
			if (document.getElementById('estado').classList.contains('is-invalid'))
				document.getElementById('estado').classList.remove('is-invalid');
		}

		if (form.municipio == null || form.municipio == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar el Municipio o Alcaldía'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('municipio').classList.add('is-invalid');
			document.getElementById('municipio').focus();

			return false;
		}else {
			if (document.getElementById('municipio').classList.contains('is-invalid'))
				document.getElementById('municipio').classList.remove('is-invalid');
		}

		if (form.colonia == 0) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar la colonia'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('colonia').classList.add('is-invalid');
			document.getElementById('colonia').focus();

			return false;
		}else {
			if (document.getElementById('colonia').classList.contains('is-invalid'))
				document.getElementById('colonia').classList.remove('is-invalid');
		}

		if (form.calle == null || form.calle == '') {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes especificar la calle'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('calle').classList.add('is-invalid');
			document.getElementById('calle').focus();

			return false;
		}else {
			if (document.getElementById('calle').classList.contains('is-invalid'))
				document.getElementById('calle').classList.remove('is-invalid');
		}

		if (!form.politicas) {
			swal({
				type: 'error'
				,title: 'Oops...'
				,text: 'Debes aceptar las políticas de privacidad'
				,toast: true
		        ,position: 'top-end'
		        ,showConfirmButton: false
		        ,timer: time
			});

			document.getElementById('politicas').classList.add('is-invalid');
			document.getElementById('politicas').focus();

			return false;
		}else {
			if (document.getElementById('politicas').classList.contains('is-invalid'))
				document.getElementById('politicas').classList.remove('is-invalid');
		}

		return true;
	}
}